import React, { Suspense } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import SupportButton from './components/SupportButton';
import SecurityPopup from './components/SecurityPopup';
import Stats from './components/Stats'; 

// 2. CARGA DIFERIDA (Lazy): Componentes pesados o que están "abajo"
const Services = React.lazy(() => import('./components/Services'));
const Benefits = React.lazy(() => import('./components/Benefits'));
const About = React.lazy(() => import('./components/About'));
const WorldMap = React.lazy(() => import('./components/WorldMap'));
const SuccessStories = React.lazy(() => import('./components/SuccessStories'));
const Clients = React.lazy(() => import('./components/Clients'));
const Contact = React.lazy(() => import('./components/Contact'));
const Footer = React.lazy(() => import('./components/Footer'));

const App: React.FC = () => {
  return (
    <div className="min-h-screen bg-surface text-dark-900 font-sans selection:bg-secondary selection:text-primary relative overflow-x-hidden">
      <Navbar />

      <main id="main-content" className="outline-none">
        {/* Hero: Prioridad máxima. Asegúrate de que tenga fetchPriority="high" dentro del componente */}
        <Hero />

        {/* Stats: Cargado normalmente para evitar el "bloqueo" de JS en escritorio */}
        <Stats />

        {/* Services en adelante: Se mantienen con Suspense para no sobrecargar el hilo principal */}
        <Suspense fallback={<div className="h-[900px] bg-primary/5 flex items-center justify-center italic text-primary/30">Cargando servicios...</div>}>
          <Services />
        </Suspense>

        <Suspense fallback={<div className="h-[600px] bg-surface" />}>
          <Benefits />
        </Suspense>

        <Suspense fallback={<div className="h-[550px] bg-surface/50" />}>
          <About />
        </Suspense>

        {/* WorldMap: Altura fija en fallback para evitar saltos (CLS) en escritorio */}
        <Suspense fallback={
          <div className="h-[650px] md:h-[750px] flex flex-col items-center justify-center bg-primary relative">
            <div className="w-48 h-48 border-2 border-secondary/20 border-t-secondary rounded-full animate-spin mb-4" />
            <span className="text-secondary font-display font-bold tracking-widest uppercase text-sm animate-pulse">
              Iniciando Infraestructura Global...
            </span>
          </div>
        }>
          <WorldMap />
        </Suspense>

        <Suspense fallback={<div className="h-[700px] bg-surface animate-pulse" />}>
          <SuccessStories />
        </Suspense>

        <Suspense fallback={<div className="h-[250px] bg-surface border-y border-gray-100" />}>
          <Clients />
        </Suspense>

        <Suspense fallback={<div className="h-[800px] bg-primary/5" />}>
          <Contact />
        </Suspense>
      </main>

      <Suspense fallback={<div className="h-[450px] bg-primary" />}>
        <Footer />
      </Suspense>

      <SecurityPopup />
      <SupportButton />
    </div>
  );
};

export default App;